export default __webpack_public_path__ + "images/886babdab5688bc9a620182ed00c2ca7.png";